import { mapState, mapGetters } from 'vuex';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  name: 'ArticlesStateMixins',
  computed: {
    ...mapState('content', [
      'contentItemsQueryParams',
    ]),
    ...mapGetters('campaigns', [
      campaignTypes.GET_IS_SELF_SERVICE_CAMPAIGN_ACCESSED_BY_ADMIN,
    ]),
  },
  methods: {
    isArticleUploading(article) {
      return article.state === 'IN PROGRESS' || article.state === 'INITIALISED';
    },
    isArticleFailed(article) {
      return article.state === 'FAILED';
    },
    isArticleSuccessful(article) {
      return !this.isArticleUploading(article) && !this.isArticleFailed(article);
    },
    isArticleState(article, statusMatch) {
      return article.state === statusMatch;
    },
    isArticleActive(article) {
      return this.isArticleState(article, 'PUBLISHED')
        || this.isArticleState(article, 'SCHEDULED');
    },
    isFilteredState(state) {
      return this.contentItemsQueryParams.hasOwnProperty('states') && this.contentItemsQueryParams.states === state;
    },
  },
};
